export const MESSAGE_CENTER_CONFIGURATION_TAG_NAME =
    'message-center-configuration-container' as const;
